import axios from 'axios';
import { useEffect, useState } from 'react';
import { StripeLoader, useStripeModule } from '../../../context/stripe';
import { StripeForm } from './stripe-form';
import { useStripeAppearance } from './UseStripeAppearance';

export function CustomPaymentMethodForm() {
  const { Elements, stripe } = useStripeModule();
  const appearance = useStripeAppearance();
  const [clientKey, setClientKey] = useState();
  const [country, setCountry] = useState<string | undefined>();

  useEffect(() => {
    const getClientKey = async () => {
      try {
        const response = await axios.get('/api/stripe/stripe-client-key', {
          withCredentials: true,
        });
        setClientKey(response.data.clientKey);
      } catch (error) {
        console.error('Error fetching Stripe client key:');
      }
    };
    const getLocation = async () => {
      try {
        const response = await axios.get('/api/stripe/get-location', {
          withCredentials: true,
        });
        setCountry(response.data.data?.geolocation?.country);
      } catch (error) {
        setCountry('US');
      }
    };
    getClientKey();
    getLocation();
  }, []);

  const options = {
    clientSecret: clientKey,
    appearance,
    loader: 'never',
  } as const;

  if (!clientKey) return <StripeLoader />;

  return (
    <Elements stripe={stripe!} options={options}>
      <StripeForm country={country} />
    </Elements>
  );
}
